import type { FC } from 'react';
import { getOptionIndex, getOptionValue, productIgnoresStockCheck } from '../../utils/functions';
import type { BrochureOrderProduct, OrderProductVariant } from '../../api/brochures';
import { getRequestedLanguages } from '../../locale/languages';
import { enableBrochureStockCheck } from '../../utils/constants';

interface OrderSizeColProps {
    product: Pick<BrochureOrderProduct, 'options' | 'variants'>;
    variant: Pick<
        OrderProductVariant,
        | 'ecommerce_id'
        | 'option1'
        | 'option2'
        | 'option3'
        | 'inventoryQuantity'
        | 'sku'
        | 'deliveryPeriod'
        | 'pfsDeliveryItem'
    >;
    quantityValue: number;
    onQuantityChange: (value: string) => void;
}

export const OrderSizeCol: FC<OrderSizeColProps> = ({ product, variant, quantityValue, onQuantityChange }) => {
    const language = getRequestedLanguages(window.errea_accountUserData.language);
    const productOptions = product.options.map(({ name }) => name);
    const sizeIndex = getOptionIndex(productOptions, 'taglia');
    const isOutOfStock = !variant.inventoryQuantity || variant.inventoryQuantity === 0;
    const ignoreStockCheck = !enableBrochureStockCheck || productIgnoresStockCheck(variant);
    const styleIndex = getOptionIndex(productOptions, 'stile');
    const size = getOptionValue(sizeIndex, variant, 'UNICA');
    const style = getOptionValue(styleIndex, variant);

    return (
        <div className="brochureOrderSizeCol">
            <div className="brochureOrderSizeHeader">
                {product.variants.length > 1 ? (
                    <>
                        {!!style && <span className="brochureOrderSizeSublabel">{style}</span>}
                        <span className="brochureOrderSizeLabel">{size || variant.sku}</span>
                    </>
                ) : (
                    <span className="brochureOrderSizeLabel">{language.general.one_size}</span>
                )}
                {!ignoreStockCheck && (
                    <span className="brochureOrderSizeThreshold">
                        {variant.inventoryQuantity ?? 0}
                        {language.general.quantity_suffix}
                    </span>
                )}
            </div>
            <input
                type="number"
                min="0"
                disabled={isOutOfStock && !ignoreStockCheck}
                className="brochureOrderSizeInput"
                placeholder={isOutOfStock && !ignoreStockCheck ? '-' : language.brochures.order.quantity_placeholder}
                value={quantityValue === 0 ? '' : quantityValue}
                onChange={(e) => onQuantityChange(e.target.value)}
            />
        </div>
    );
};
